/**
 * Generated by orval 🍺
 * Do not edit manually.
 * TrainLoop Platform V2 API
 * Model evaluation workbench API
 * OpenAPI spec version: 0.0.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  HTTPValidationError,
  LabelResponse,
  LabelUpsert,
  ListLabelsApiLabelsGetParams,
  TagDelete,
  TagRename,
  TagVocabularyResponse,
  TagsUpsert,
} from "../model";

import { orvalFetch } from "../../client.ts";
import type { ErrorType } from "../../client.ts";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(
  query: T,
  queryKey: K,
): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type listTagVocabularyApiLabelsTagsGetResponse200 = {
  data: TagVocabularyResponse;
  status: 200;
};

export type listTagVocabularyApiLabelsTagsGetResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type listTagVocabularyApiLabelsTagsGetResponseSuccess =
  listTagVocabularyApiLabelsTagsGetResponse200 & {
    headers: Headers;
  };
export type listTagVocabularyApiLabelsTagsGetResponseError =
  listTagVocabularyApiLabelsTagsGetResponse422 & {
    headers: Headers;
  };

export type listTagVocabularyApiLabelsTagsGetResponse =
  | listTagVocabularyApiLabelsTagsGetResponseSuccess
  | listTagVocabularyApiLabelsTagsGetResponseError;

export const getListTagVocabularyApiLabelsTagsGetUrl = () => {
  return `/api/labels/tags`;
};

/**
 * The team's distinct tag vocabulary — feeds filter chips and combobox.
 * @summary List Tag Vocabulary
 */
export const listTagVocabularyApiLabelsTagsGet = async (
  options?: Parameters<typeof orvalFetch>[1],
): Promise<listTagVocabularyApiLabelsTagsGetResponse> => {
  return orvalFetch<listTagVocabularyApiLabelsTagsGetResponse>(
    getListTagVocabularyApiLabelsTagsGetUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListTagVocabularyApiLabelsTagsGetQueryKey = () => {
  return [`/api/labels/tags`] as const;
};

export const getListTagVocabularyApiLabelsTagsGetQueryOptions = <
  TData = Awaited<ReturnType<typeof listTagVocabularyApiLabelsTagsGet>>,
  TError = ErrorType<HTTPValidationError>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof listTagVocabularyApiLabelsTagsGet>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof orvalFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListTagVocabularyApiLabelsTagsGetQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listTagVocabularyApiLabelsTagsGet>>
  > = ({ signal }) =>
    listTagVocabularyApiLabelsTagsGet({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listTagVocabularyApiLabelsTagsGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListTagVocabularyApiLabelsTagsGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof listTagVocabularyApiLabelsTagsGet>>
>;
export type ListTagVocabularyApiLabelsTagsGetQueryError =
  ErrorType<HTTPValidationError>;

export function useListTagVocabularyApiLabelsTagsGet<
  TData = Awaited<ReturnType<typeof listTagVocabularyApiLabelsTagsGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listTagVocabularyApiLabelsTagsGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTagVocabularyApiLabelsTagsGet>>,
          TError,
          Awaited<ReturnType<typeof listTagVocabularyApiLabelsTagsGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListTagVocabularyApiLabelsTagsGet<
  TData = Awaited<ReturnType<typeof listTagVocabularyApiLabelsTagsGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listTagVocabularyApiLabelsTagsGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTagVocabularyApiLabelsTagsGet>>,
          TError,
          Awaited<ReturnType<typeof listTagVocabularyApiLabelsTagsGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListTagVocabularyApiLabelsTagsGet<
  TData = Awaited<ReturnType<typeof listTagVocabularyApiLabelsTagsGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listTagVocabularyApiLabelsTagsGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List Tag Vocabulary
 */

export function useListTagVocabularyApiLabelsTagsGet<
  TData = Awaited<ReturnType<typeof listTagVocabularyApiLabelsTagsGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listTagVocabularyApiLabelsTagsGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getListTagVocabularyApiLabelsTagsGetQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type upsertTagsApiLabelsTagsPostResponse200 = {
  data: LabelResponse | null;
  status: 200;
};

export type upsertTagsApiLabelsTagsPostResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type upsertTagsApiLabelsTagsPostResponseSuccess =
  upsertTagsApiLabelsTagsPostResponse200 & {
    headers: Headers;
  };
export type upsertTagsApiLabelsTagsPostResponseError =
  upsertTagsApiLabelsTagsPostResponse422 & {
    headers: Headers;
  };

export type upsertTagsApiLabelsTagsPostResponse =
  | upsertTagsApiLabelsTagsPostResponseSuccess
  | upsertTagsApiLabelsTagsPostResponseError;

export const getUpsertTagsApiLabelsTagsPostUrl = () => {
  return `/api/labels/tags`;
};

/**
 * Replace the tag set on one trace, touching nothing else (TRA-939).
 *
 * Creates the labels row when the trace has never been flagged — as
 * `review_status='reviewed'`, because a default-'unreviewed' row would put
 * the run into the review queue as if a validator had flagged it. With
 * empty `notes` it is also inert to the eval-PR agent, which requires
 * non-empty notes.
 *
 * With `conversation_id` set the save is run-scoped: the set applies to
 * the named (representative) trace, and removals propagate to the
 * conversation's other labeled traces.
 * @summary Upsert Tags
 */
export const upsertTagsApiLabelsTagsPost = async (
  tagsUpsert: TagsUpsert,
  options?: Parameters<typeof orvalFetch>[1],
): Promise<upsertTagsApiLabelsTagsPostResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(
          h as Iterable<Iterable<string>>,
          (entry) => Array.from(entry) as [string, string],
        ),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<
      string | readonly string[] | undefined
    >(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  return orvalFetch<upsertTagsApiLabelsTagsPostResponse>(
    getUpsertTagsApiLabelsTagsPostUrl(),
    {
      ...options,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...getHeaders(options?.headers),
      },
      body: JSON.stringify(tagsUpsert),
    },
  );
};

export const getUpsertTagsApiLabelsTagsPostMutationKey = () =>
  ["upsertTagsApiLabelsTagsPost"] as const;

export const getUpsertTagsApiLabelsTagsPostMutationOptions = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof upsertTagsApiLabelsTagsPost>>,
    TError,
    UpsertTagsApiLabelsTagsPostMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof orvalFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof upsertTagsApiLabelsTagsPost>>,
  TError,
  UpsertTagsApiLabelsTagsPostMutationVariables,
  TContext
> => {
  const mutationKey = getUpsertTagsApiLabelsTagsPostMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof upsertTagsApiLabelsTagsPost>>,
    UpsertTagsApiLabelsTagsPostMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return upsertTagsApiLabelsTagsPost(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpsertTagsApiLabelsTagsPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof upsertTagsApiLabelsTagsPost>>
>;
export type UpsertTagsApiLabelsTagsPostMutationBody = TagsUpsert;
export type UpsertTagsApiLabelsTagsPostMutationError =
  ErrorType<HTTPValidationError>;
export type UpsertTagsApiLabelsTagsPostMutationVariables = { data: TagsUpsert };

/**
 * @summary Upsert Tags
 */
export const useUpsertTagsApiLabelsTagsPost = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof upsertTagsApiLabelsTagsPost>>,
      TError,
      UpsertTagsApiLabelsTagsPostMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof upsertTagsApiLabelsTagsPost>>,
  TError,
  UpsertTagsApiLabelsTagsPostMutationVariables,
  TContext
> => {
  return useMutation(
    getUpsertTagsApiLabelsTagsPostMutationOptions(options),
    queryClient,
  );
};
export type renameTagApiLabelsTagsRenamePostResponse200 = {
  data: TagVocabularyResponse;
  status: 200;
};

export type renameTagApiLabelsTagsRenamePostResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type renameTagApiLabelsTagsRenamePostResponseSuccess =
  renameTagApiLabelsTagsRenamePostResponse200 & {
    headers: Headers;
  };
export type renameTagApiLabelsTagsRenamePostResponseError =
  renameTagApiLabelsTagsRenamePostResponse422 & {
    headers: Headers;
  };

export type renameTagApiLabelsTagsRenamePostResponse =
  | renameTagApiLabelsTagsRenamePostResponseSuccess
  | renameTagApiLabelsTagsRenamePostResponseError;

export const getRenameTagApiLabelsTagsRenamePostUrl = () => {
  return `/api/labels/tags/rename`;
};

/**
 * Rename a tag on every run carrying it; merges into an existing tag.
 *
 * The new name is normalized and folded onto the team's existing casing,
 * so renaming `tl` to `quoting` when `Quoting` exists merges rather than
 * forking the vocabulary.
 * @summary Rename Tag
 */
export const renameTagApiLabelsTagsRenamePost = async (
  tagRename: TagRename,
  options?: Parameters<typeof orvalFetch>[1],
): Promise<renameTagApiLabelsTagsRenamePostResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(
          h as Iterable<Iterable<string>>,
          (entry) => Array.from(entry) as [string, string],
        ),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<
      string | readonly string[] | undefined
    >(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  return orvalFetch<renameTagApiLabelsTagsRenamePostResponse>(
    getRenameTagApiLabelsTagsRenamePostUrl(),
    {
      ...options,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...getHeaders(options?.headers),
      },
      body: JSON.stringify(tagRename),
    },
  );
};

export const getRenameTagApiLabelsTagsRenamePostMutationKey = () =>
  ["renameTagApiLabelsTagsRenamePost"] as const;

export const getRenameTagApiLabelsTagsRenamePostMutationOptions = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof renameTagApiLabelsTagsRenamePost>>,
    TError,
    RenameTagApiLabelsTagsRenamePostMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof orvalFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof renameTagApiLabelsTagsRenamePost>>,
  TError,
  RenameTagApiLabelsTagsRenamePostMutationVariables,
  TContext
> => {
  const mutationKey = getRenameTagApiLabelsTagsRenamePostMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof renameTagApiLabelsTagsRenamePost>>,
    RenameTagApiLabelsTagsRenamePostMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return renameTagApiLabelsTagsRenamePost(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RenameTagApiLabelsTagsRenamePostMutationResult = NonNullable<
  Awaited<ReturnType<typeof renameTagApiLabelsTagsRenamePost>>
>;
export type RenameTagApiLabelsTagsRenamePostMutationBody = TagRename;
export type RenameTagApiLabelsTagsRenamePostMutationError =
  ErrorType<HTTPValidationError>;
export type RenameTagApiLabelsTagsRenamePostMutationVariables = {
  data: TagRename;
};

/**
 * @summary Rename Tag
 */
export const useRenameTagApiLabelsTagsRenamePost = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof renameTagApiLabelsTagsRenamePost>>,
      TError,
      RenameTagApiLabelsTagsRenamePostMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof renameTagApiLabelsTagsRenamePost>>,
  TError,
  RenameTagApiLabelsTagsRenamePostMutationVariables,
  TContext
> => {
  return useMutation(
    getRenameTagApiLabelsTagsRenamePostMutationOptions(options),
    queryClient,
  );
};
export type deleteTagApiLabelsTagsDeletePostResponse200 = {
  data: TagVocabularyResponse;
  status: 200;
};

export type deleteTagApiLabelsTagsDeletePostResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type deleteTagApiLabelsTagsDeletePostResponseSuccess =
  deleteTagApiLabelsTagsDeletePostResponse200 & {
    headers: Headers;
  };
export type deleteTagApiLabelsTagsDeletePostResponseError =
  deleteTagApiLabelsTagsDeletePostResponse422 & {
    headers: Headers;
  };

export type deleteTagApiLabelsTagsDeletePostResponse =
  | deleteTagApiLabelsTagsDeletePostResponseSuccess
  | deleteTagApiLabelsTagsDeletePostResponseError;

export const getDeleteTagApiLabelsTagsDeletePostUrl = () => {
  return `/api/labels/tags/delete`;
};

/**
 * Remove a tag from every run carrying it.
 *
 * A tag-only bookkeeping row whose last tag is removed is deleted, same
 * as the tag editor's remove-last-tag path.
 * @summary Delete Tag
 */
export const deleteTagApiLabelsTagsDeletePost = async (
  tagDelete: TagDelete,
  options?: Parameters<typeof orvalFetch>[1],
): Promise<deleteTagApiLabelsTagsDeletePostResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(
          h as Iterable<Iterable<string>>,
          (entry) => Array.from(entry) as [string, string],
        ),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<
      string | readonly string[] | undefined
    >(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  return orvalFetch<deleteTagApiLabelsTagsDeletePostResponse>(
    getDeleteTagApiLabelsTagsDeletePostUrl(),
    {
      ...options,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...getHeaders(options?.headers),
      },
      body: JSON.stringify(tagDelete),
    },
  );
};

export const getDeleteTagApiLabelsTagsDeletePostMutationKey = () =>
  ["deleteTagApiLabelsTagsDeletePost"] as const;

export const getDeleteTagApiLabelsTagsDeletePostMutationOptions = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteTagApiLabelsTagsDeletePost>>,
    TError,
    DeleteTagApiLabelsTagsDeletePostMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof orvalFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteTagApiLabelsTagsDeletePost>>,
  TError,
  DeleteTagApiLabelsTagsDeletePostMutationVariables,
  TContext
> => {
  const mutationKey = getDeleteTagApiLabelsTagsDeletePostMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteTagApiLabelsTagsDeletePost>>,
    DeleteTagApiLabelsTagsDeletePostMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return deleteTagApiLabelsTagsDeletePost(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteTagApiLabelsTagsDeletePostMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteTagApiLabelsTagsDeletePost>>
>;
export type DeleteTagApiLabelsTagsDeletePostMutationBody = TagDelete;
export type DeleteTagApiLabelsTagsDeletePostMutationError =
  ErrorType<HTTPValidationError>;
export type DeleteTagApiLabelsTagsDeletePostMutationVariables = {
  data: TagDelete;
};

/**
 * @summary Delete Tag
 */
export const useDeleteTagApiLabelsTagsDeletePost = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteTagApiLabelsTagsDeletePost>>,
      TError,
      DeleteTagApiLabelsTagsDeletePostMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteTagApiLabelsTagsDeletePost>>,
  TError,
  DeleteTagApiLabelsTagsDeletePostMutationVariables,
  TContext
> => {
  return useMutation(
    getDeleteTagApiLabelsTagsDeletePostMutationOptions(options),
    queryClient,
  );
};
export type listLabelsApiLabelsGetResponse200 = {
  data: LabelResponse[];
  status: 200;
};

export type listLabelsApiLabelsGetResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type listLabelsApiLabelsGetResponseSuccess =
  listLabelsApiLabelsGetResponse200 & {
    headers: Headers;
  };
export type listLabelsApiLabelsGetResponseError =
  listLabelsApiLabelsGetResponse422 & {
    headers: Headers;
  };

export type listLabelsApiLabelsGetResponse =
  | listLabelsApiLabelsGetResponseSuccess
  | listLabelsApiLabelsGetResponseError;

export const getListLabelsApiLabelsGetUrl = (
  params?: ListLabelsApiLabelsGetParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/labels?${stringifiedParams}`
    : `/api/labels`;
};

/**
 * List all labels for the team, newest first. The notes are the
 * reviewers' own words, so the read is recorded in the team's audit
 * log (TRA-1626).
 * @summary List Labels
 */
export const listLabelsApiLabelsGet = async (
  params?: ListLabelsApiLabelsGetParams,
  options?: Parameters<typeof orvalFetch>[1],
): Promise<listLabelsApiLabelsGetResponse> => {
  return orvalFetch<listLabelsApiLabelsGetResponse>(
    getListLabelsApiLabelsGetUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListLabelsApiLabelsGetQueryKey = (
  params?: ListLabelsApiLabelsGetParams,
) => {
  return [`/api/labels`, ...(params ? [params] : [])] as const;
};

export const getListLabelsApiLabelsGetQueryOptions = <
  TData = Awaited<ReturnType<typeof listLabelsApiLabelsGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  params?: ListLabelsApiLabelsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listLabelsApiLabelsGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListLabelsApiLabelsGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listLabelsApiLabelsGet>>
  > = ({ signal }) =>
    listLabelsApiLabelsGet(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listLabelsApiLabelsGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListLabelsApiLabelsGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof listLabelsApiLabelsGet>>
>;
export type ListLabelsApiLabelsGetQueryError = ErrorType<HTTPValidationError>;

export function useListLabelsApiLabelsGet<
  TData = Awaited<ReturnType<typeof listLabelsApiLabelsGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  params: undefined | ListLabelsApiLabelsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listLabelsApiLabelsGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listLabelsApiLabelsGet>>,
          TError,
          Awaited<ReturnType<typeof listLabelsApiLabelsGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListLabelsApiLabelsGet<
  TData = Awaited<ReturnType<typeof listLabelsApiLabelsGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  params?: ListLabelsApiLabelsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listLabelsApiLabelsGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listLabelsApiLabelsGet>>,
          TError,
          Awaited<ReturnType<typeof listLabelsApiLabelsGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListLabelsApiLabelsGet<
  TData = Awaited<ReturnType<typeof listLabelsApiLabelsGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  params?: ListLabelsApiLabelsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listLabelsApiLabelsGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List Labels
 */

export function useListLabelsApiLabelsGet<
  TData = Awaited<ReturnType<typeof listLabelsApiLabelsGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  params?: ListLabelsApiLabelsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listLabelsApiLabelsGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListLabelsApiLabelsGetQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type upsertLabelApiLabelsPostResponse200 = {
  data: LabelResponse;
  status: 200;
};

export type upsertLabelApiLabelsPostResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type upsertLabelApiLabelsPostResponseSuccess =
  upsertLabelApiLabelsPostResponse200 & {
    headers: Headers;
  };
export type upsertLabelApiLabelsPostResponseError =
  upsertLabelApiLabelsPostResponse422 & {
    headers: Headers;
  };

export type upsertLabelApiLabelsPostResponse =
  | upsertLabelApiLabelsPostResponseSuccess
  | upsertLabelApiLabelsPostResponseError;

export const getUpsertLabelApiLabelsPostUrl = () => {
  return `/api/labels`;
};

/**
 * Create or update the team's label for a single trace_id.
 *
 * Posting twice with the same trace_id replaces the existing row's
 * approved / notes; created_by is preserved. `rubric_scores` and
 * `review_status` update only when present in the request — omission
 * preserves the stored values.
 * @summary Upsert Label
 */
export const upsertLabelApiLabelsPost = async (
  labelUpsert: LabelUpsert,
  options?: Parameters<typeof orvalFetch>[1],
): Promise<upsertLabelApiLabelsPostResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(
          h as Iterable<Iterable<string>>,
          (entry) => Array.from(entry) as [string, string],
        ),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<
      string | readonly string[] | undefined
    >(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  return orvalFetch<upsertLabelApiLabelsPostResponse>(
    getUpsertLabelApiLabelsPostUrl(),
    {
      ...options,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...getHeaders(options?.headers),
      },
      body: JSON.stringify(labelUpsert),
    },
  );
};

export const getUpsertLabelApiLabelsPostMutationKey = () =>
  ["upsertLabelApiLabelsPost"] as const;

export const getUpsertLabelApiLabelsPostMutationOptions = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof upsertLabelApiLabelsPost>>,
    TError,
    UpsertLabelApiLabelsPostMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof orvalFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof upsertLabelApiLabelsPost>>,
  TError,
  UpsertLabelApiLabelsPostMutationVariables,
  TContext
> => {
  const mutationKey = getUpsertLabelApiLabelsPostMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof upsertLabelApiLabelsPost>>,
    UpsertLabelApiLabelsPostMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return upsertLabelApiLabelsPost(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpsertLabelApiLabelsPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof upsertLabelApiLabelsPost>>
>;
export type UpsertLabelApiLabelsPostMutationBody = LabelUpsert;
export type UpsertLabelApiLabelsPostMutationError =
  ErrorType<HTTPValidationError>;
export type UpsertLabelApiLabelsPostMutationVariables = { data: LabelUpsert };

/**
 * @summary Upsert Label
 */
export const useUpsertLabelApiLabelsPost = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof upsertLabelApiLabelsPost>>,
      TError,
      UpsertLabelApiLabelsPostMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof upsertLabelApiLabelsPost>>,
  TError,
  UpsertLabelApiLabelsPostMutationVariables,
  TContext
> => {
  return useMutation(
    getUpsertLabelApiLabelsPostMutationOptions(options),
    queryClient,
  );
};
export type getLabelByTraceApiLabelsByTraceTraceIdGetResponse200 = {
  data: LabelResponse;
  status: 200;
};

export type getLabelByTraceApiLabelsByTraceTraceIdGetResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getLabelByTraceApiLabelsByTraceTraceIdGetResponseSuccess =
  getLabelByTraceApiLabelsByTraceTraceIdGetResponse200 & {
    headers: Headers;
  };
export type getLabelByTraceApiLabelsByTraceTraceIdGetResponseError =
  getLabelByTraceApiLabelsByTraceTraceIdGetResponse422 & {
    headers: Headers;
  };

export type getLabelByTraceApiLabelsByTraceTraceIdGetResponse =
  | getLabelByTraceApiLabelsByTraceTraceIdGetResponseSuccess
  | getLabelByTraceApiLabelsByTraceTraceIdGetResponseError;

export const getGetLabelByTraceApiLabelsByTraceTraceIdGetUrl = (
  traceId: string,
) => {
  return `/api/labels/by-trace/${traceId}`;
};

/**
 * Look up the team's label on a single trace; the read is recorded
 * in the team's audit log (TRA-1626).
 *
 * Path param uses `:path` so trace IDs containing slashes (rare but
 * possible if a future trace-id scheme adopts them) survive routing.
 * @summary Get Label By Trace
 */
export const getLabelByTraceApiLabelsByTraceTraceIdGet = async (
  traceId: string,
  options?: Parameters<typeof orvalFetch>[1],
): Promise<getLabelByTraceApiLabelsByTraceTraceIdGetResponse> => {
  return orvalFetch<getLabelByTraceApiLabelsByTraceTraceIdGetResponse>(
    getGetLabelByTraceApiLabelsByTraceTraceIdGetUrl(traceId),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetLabelByTraceApiLabelsByTraceTraceIdGetQueryKey = (
  traceId: string,
) => {
  return [`/api/labels/by-trace/${traceId}`] as const;
};

export const getGetLabelByTraceApiLabelsByTraceTraceIdGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getLabelByTraceApiLabelsByTraceTraceIdGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  traceId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getLabelByTraceApiLabelsByTraceTraceIdGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetLabelByTraceApiLabelsByTraceTraceIdGetQueryKey(traceId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getLabelByTraceApiLabelsByTraceTraceIdGet>>
  > = ({ signal }) =>
    getLabelByTraceApiLabelsByTraceTraceIdGet(traceId, {
      signal,
      ...requestOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: traceId !== null && traceId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getLabelByTraceApiLabelsByTraceTraceIdGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetLabelByTraceApiLabelsByTraceTraceIdGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getLabelByTraceApiLabelsByTraceTraceIdGet>>
>;
export type GetLabelByTraceApiLabelsByTraceTraceIdGetQueryError =
  ErrorType<HTTPValidationError>;

export function useGetLabelByTraceApiLabelsByTraceTraceIdGet<
  TData = Awaited<ReturnType<typeof getLabelByTraceApiLabelsByTraceTraceIdGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  traceId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getLabelByTraceApiLabelsByTraceTraceIdGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLabelByTraceApiLabelsByTraceTraceIdGet>>,
          TError,
          Awaited<ReturnType<typeof getLabelByTraceApiLabelsByTraceTraceIdGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetLabelByTraceApiLabelsByTraceTraceIdGet<
  TData = Awaited<ReturnType<typeof getLabelByTraceApiLabelsByTraceTraceIdGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  traceId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getLabelByTraceApiLabelsByTraceTraceIdGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLabelByTraceApiLabelsByTraceTraceIdGet>>,
          TError,
          Awaited<ReturnType<typeof getLabelByTraceApiLabelsByTraceTraceIdGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetLabelByTraceApiLabelsByTraceTraceIdGet<
  TData = Awaited<ReturnType<typeof getLabelByTraceApiLabelsByTraceTraceIdGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  traceId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getLabelByTraceApiLabelsByTraceTraceIdGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Label By Trace
 */

export function useGetLabelByTraceApiLabelsByTraceTraceIdGet<
  TData = Awaited<ReturnType<typeof getLabelByTraceApiLabelsByTraceTraceIdGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  traceId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getLabelByTraceApiLabelsByTraceTraceIdGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetLabelByTraceApiLabelsByTraceTraceIdGetQueryOptions(
    traceId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type removeFlagApiLabelsFlagByTraceTraceIdDeleteResponse200 = {
  data: LabelResponse | null;
  status: 200;
};

export type removeFlagApiLabelsFlagByTraceTraceIdDeleteResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type removeFlagApiLabelsFlagByTraceTraceIdDeleteResponseSuccess =
  removeFlagApiLabelsFlagByTraceTraceIdDeleteResponse200 & {
    headers: Headers;
  };
export type removeFlagApiLabelsFlagByTraceTraceIdDeleteResponseError =
  removeFlagApiLabelsFlagByTraceTraceIdDeleteResponse422 & {
    headers: Headers;
  };

export type removeFlagApiLabelsFlagByTraceTraceIdDeleteResponse =
  | removeFlagApiLabelsFlagByTraceTraceIdDeleteResponseSuccess
  | removeFlagApiLabelsFlagByTraceTraceIdDeleteResponseError;

export const getRemoveFlagApiLabelsFlagByTraceTraceIdDeleteUrl = (
  traceId: string,
) => {
  return `/api/labels/flag/by-trace/${traceId}`;
};

/**
 * Remove the good/bad flag from the RUN this trace belongs to (TRA-963).
 *
 * Run-scoped, like the conversation-scoped tag save: a conversation can
 * carry a flag on several turns and the trajectories row shows only the
 * newest, so clearing that one alone would promote the next-newest and
 * leave the run still flagged (`_run_flag_labels`). Every flagged turn
 * goes in ONE transaction.
 *
 * Each row carrying tags degrades to the tag-only bookkeeping shape; each
 * row with nothing left to hold is deleted. The response is the named
 * trace's surviving row, or null when it was deleted.
 *
 * This throws the feedback away, and it leaves the run scannable again —
 * see `strip_flag` for why that is deliberate and how narrow it is.
 * Dismissing (POST with `review_status='dismissed'`) is the reversible
 * option: it keeps the flag as a record AND settles the run against the
 * review scan. The trajectories page offers both, and says which is
 * which.
 * @summary Remove Flag
 */
export const removeFlagApiLabelsFlagByTraceTraceIdDelete = async (
  traceId: string,
  options?: Parameters<typeof orvalFetch>[1],
): Promise<removeFlagApiLabelsFlagByTraceTraceIdDeleteResponse> => {
  return orvalFetch<removeFlagApiLabelsFlagByTraceTraceIdDeleteResponse>(
    getRemoveFlagApiLabelsFlagByTraceTraceIdDeleteUrl(traceId),
    {
      ...options,
      method: "DELETE",
    },
  );
};

export const getRemoveFlagApiLabelsFlagByTraceTraceIdDeleteMutationKey = () =>
  ["removeFlagApiLabelsFlagByTraceTraceIdDelete"] as const;

export const getRemoveFlagApiLabelsFlagByTraceTraceIdDeleteMutationOptions = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removeFlagApiLabelsFlagByTraceTraceIdDelete>>,
    TError,
    RemoveFlagApiLabelsFlagByTraceTraceIdDeleteMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof orvalFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof removeFlagApiLabelsFlagByTraceTraceIdDelete>>,
  TError,
  RemoveFlagApiLabelsFlagByTraceTraceIdDeleteMutationVariables,
  TContext
> => {
  const mutationKey =
    getRemoveFlagApiLabelsFlagByTraceTraceIdDeleteMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof removeFlagApiLabelsFlagByTraceTraceIdDelete>>,
    RemoveFlagApiLabelsFlagByTraceTraceIdDeleteMutationVariables
  > = (props) => {
    const { traceId } = props ?? {};

    return removeFlagApiLabelsFlagByTraceTraceIdDelete(traceId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RemoveFlagApiLabelsFlagByTraceTraceIdDeleteMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof removeFlagApiLabelsFlagByTraceTraceIdDelete>>
  >;

export type RemoveFlagApiLabelsFlagByTraceTraceIdDeleteMutationError =
  ErrorType<HTTPValidationError>;
export type RemoveFlagApiLabelsFlagByTraceTraceIdDeleteMutationVariables = {
  traceId: string;
};

/**
 * @summary Remove Flag
 */
export const useRemoveFlagApiLabelsFlagByTraceTraceIdDelete = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof removeFlagApiLabelsFlagByTraceTraceIdDelete>>,
      TError,
      RemoveFlagApiLabelsFlagByTraceTraceIdDeleteMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof removeFlagApiLabelsFlagByTraceTraceIdDelete>>,
  TError,
  RemoveFlagApiLabelsFlagByTraceTraceIdDeleteMutationVariables,
  TContext
> => {
  return useMutation(
    getRemoveFlagApiLabelsFlagByTraceTraceIdDeleteMutationOptions(options),
    queryClient,
  );
};
